import { useCallback } from 'react';
import { useResetRecoilState } from 'recoil';
import {
    replanningDoseMappingState,
    replanningDoseScaleState,
    replanningDvhComparisonOpenState,
    replanningMappedDosesState,
    replanningReconciledStructuresState,
    replanningReviewedDosesState,
    replanningReviewTransformState,
    replanningRigidStructuresState,
    replanningRigidStructuresStatusState,
} from '~/state/atoms/adaptiveReplanningAtoms';

// Forgets Review's transform, scale, computed doses, dose sign-off, reconciled colors, rigid structures and panels.
export function useResetReviewState(): () => void {
    const resetTransform = useResetRecoilState(replanningReviewTransformState);
    const resetScale = useResetRecoilState(replanningDoseScaleState);
    const resetMappedDoses = useResetRecoilState(replanningMappedDosesState);
    const resetMapping = useResetRecoilState(replanningDoseMappingState);
    const resetReviewedDoses = useResetRecoilState(
        replanningReviewedDosesState
    );
    const resetReconciled = useResetRecoilState(
        replanningReconciledStructuresState
    );
    const resetRigid = useResetRecoilState(replanningRigidStructuresState);
    const resetRigidStatus = useResetRecoilState(
        replanningRigidStructuresStatusState
    );
    const resetDvhOpen = useResetRecoilState(replanningDvhComparisonOpenState);
    return useCallback(() => {
        resetTransform();
        resetScale();
        resetMappedDoses();
        resetMapping();
        resetReviewedDoses();
        resetReconciled();
        resetRigid();
        resetRigidStatus();
        resetDvhOpen();
    }, [
        resetTransform,
        resetScale,
        resetMappedDoses,
        resetMapping,
        resetReviewedDoses,
        resetReconciled,
        resetRigid,
        resetRigidStatus,
        resetDvhOpen,
    ]);
}
